import {validateRingCommonFields} from './validations/ring-common-fields'
import {validatePrimaryDiamondFields} from './validations/primary-diamond-fields'
import {validateCentreHaloFields} from './validations/centre-halo-fields'
import {validateHaloSideDiamondFields} from './validations/halo-side-diamond-fields'
import {validateMultiStoneFields} from './validations/multi-stone-fields'
import {validateMultiStoneHaloFields} from './validations/multi-stone-halo-fields'
import {validateShankTopDiamondFields} from './validations/shank-top-diamond-fields'
import {validateShankSideDiamondFields} from './validations/shank-side-diamond-fields'
import {validateAdditionalDiamondFields} from './validations/additional-diamond-fields'
import {validateBailFields} from './validations/bail-fields'
import {validateBailDiamondFields} from './validations/bail-diamond-fields'
import {validatePendantChainFields} from './validations/pendant-chain-fields'
import {validateProngFields} from './validations/prong-fields'
import {validateAdditionalOptionFields} from './validations/additional-option-fields'
import {validateStockItemFields} from './validations/stock-item-fields'
import {
  showHaloSideDiamondPanel,
  showMultiStoneHaloPanel,
  showPrimaryDiamondPanel,
  jewelryTypeIsRing,
  showPrimaryDiamondHaloPanel,
  showProngPanel,
  showBailPanel,
  showAdditionalDiamondPanel,
  showAdditionalOptionPanel,
  showPrimaryMetalTypePanel
} from '../../utils/jewelry-validation'
import _ from 'lodash'

const validateJewelryType = (filters) => {
  let errs = []
  if (filters.jewelry_type === null) {
    errs = errs.concat(['Product Type'])
  }
  return errs
}

const validatePrimaryMetalType = (filters) => {
  let errs = []
  if (showPrimaryMetalTypePanel(filters) && filters.primary_metal_type === null) {
    errs = errs.concat(['Primary Metal'])
  }
  return errs
}

const validateHaloSideDiamond = (filters) => {
  let errs = []
  if (showHaloSideDiamondPanel(filters)) {
    if (filters.diamonds_on_outside_of_halo === null) {
      errs = errs.concat(['Diamonds on Outside Sides of Halo'])
    } else if (filters.diamonds_on_outside_of_halo) {
      errs = errs.concat(validateHaloSideDiamondFields(filters))
    }
  }
  return errs
}

const validatePrimaryDiamondHalo = (filters) => {
  let errs = []
  if (showPrimaryDiamondHaloPanel(filters)) {
    if (filters.has_central_halo === null) {
      errs = errs.concat(['Centre Halo?'])
    } else if (filters.has_central_halo) {
      errs = errs.concat(validateCentreHaloFields(filters))
      errs = errs.concat(validatorFactory.validateHaloSideDiamond(filters))
    }
  }
  return errs
}

export const validatePrimaryDiamond = (filters) => {
  let errs = []
  if (showPrimaryDiamondPanel(filters)) {
    errs = errs.concat(validatePrimaryDiamondFields(filters))
    errs = errs.concat(validatorFactory.validatePrimaryDiamondHalo(filters))
  }
  return errs
}

export const validateMultiStoneHalo = (filters) => {
  let errs = []
  if (showMultiStoneHaloPanel(filters)) {
    if (filters.has_side_stone_halo === null) {
      errs = errs.concat(['Multi-Stone Halo'])
    } else if (filters.has_side_stone_halo) {
      errs = errs.concat(validateMultiStoneHaloFields(filters))
    }
  }
  return errs
}

export const validateMultiStone = (filters) => {
  let errs = []
  if (filters.jewelry_type !== 'MaleWeddingBand') {
    if (filters.multi_stone_ring === null) {
      errs = errs.concat(['Multi-Stone Ring?'])
    } else if (filters.multi_stone_ring) {
      errs = errs.concat(validateMultiStoneFields(filters))
      errs = errs.concat(validatorFactory.validateMultiStoneHalo(filters))
    }
  }
  return errs
}

export const validateShankTopDiamond = (filters) => {
  let errs = []
  if (filters.has_diamonds_down_top_of_shank === null) {
    errs = errs.concat(['Diamonds Down Top of Shank?'])
  } else if (filters.has_diamonds_down_top_of_shank) {
    errs = errs.concat(validateShankTopDiamondFields(filters))
  }
  return errs
}

export const validateShankSideDiamond = (filters) => {
  let errs = []
  if (filters.diamonds_on_outside_sides_of_shank === null) {
    errs = errs.concat(['Diamonds on Outside Sides of Shank?'])
  } else if (filters.diamonds_on_outside_sides_of_shank) {
    errs = errs.concat(validateShankSideDiamondFields(filters))
  }
  return errs
}

export const validateRing = (filters) => {
  let errs = []
  if (jewelryTypeIsRing(filters)) {
    errs = errs.concat(validateRingCommonFields(filters))
    errs = errs.concat(validatorFactory.validateMultiStone(filters))
    errs = errs.concat(validatorFactory.validateShankTopDiamond(filters))
    errs = errs.concat(validatorFactory.validateShankSideDiamond(filters))
  }
  return errs
}

export const validateBailDiamond = (filters) => {
  let errs = []
  if (filters.has_bail_diamond === null) {
    errs = errs.concat(['Diamonds on Bail?'])
  } else if (filters.has_bail_diamond) {
    errs = errs.concat(validateBailDiamondFields(filters))
  }
  return errs
}

export const validateBail = (filters) => {
  let errs = []
  if (filters.jewelry_type !== 'Pendant' || !showBailPanel(filters)) {
    return errs
  }
  if (filters.has_bail === null) {
    errs = errs.concat(['Bail?'])
  } else if (filters.has_bail) {
    errs = errs.concat(validateBailFields(filters))
    errs = errs.concat(validatorFactory.validateBailDiamond(filters))
  }
  return errs
}

export const validatePendantChain = (filters) => {
  let errs = []
  if (filters.jewelry_type !== 'Pendant') {
    return errs
  }
  if (filters.has_pendant_chain === null) {
    errs = errs.concat(['Chain?'])
  } else if (filters.has_pendant_chain) {
    errs = errs.concat(validatePendantChainFields(filters))
  }
  return errs
}

export const validateBasketType = (filters) => {
  let errs = []
  if ((filters.jewelry_type === 'Pendant' || filters.jewelry_type === 'StudEarring') && filters.basket_type === null) {
    errs = errs.concat(['basket_type'])
  }
  return errs
}

export const validateProng = (filters) => {
  let errs = []
  if (showProngPanel(filters)) {
    errs = errs.concat(validateProngFields(filters))
  }
  return errs
}

export const validateAdditionalDiamond = (filters) => {
  let errs = []
  if (showAdditionalDiamondPanel(filters) && !_.isEmpty(filters.additional_diamonds)) {
    _.values(filters.additional_diamonds).forEach((additionalDiamond) => {
      errs = errs.concat(validateAdditionalDiamondFields(additionalDiamond))
    })
  }
  return errs
}

export const validateAdditionalOption = (filters) => {
  let errs = []
  if (showAdditionalOptionPanel(filters)) {
    errs = errs.concat(validateAdditionalOptionFields(filters))
  }
  return errs
}

export const validateStockItem = (filters) => {
  let errs = []
  if (filters.jewelry_type === 'StockItem') {
    errs = errs.concat(validateStockItemFields(filters))
  }
  return errs
}

export const validateAdditionalChargeCurrency = (filters) => {
  let errs = []
  if (filters.additional_price < 0) {
    errs = errs.concat(['Additional Charge'])
  }
  if (filters.additional_price > 0 && _.isNil(filters.additional_price_currency)) {
    errs = errs.concat(['additional_charge_currency'])
  }
  return errs
}

export const validateForm = (filters) => {
  let errs = []
  errs = errs.concat(validatorFactory.validateJewelryType(filters))
  errs = errs.concat(validatorFactory.validatePrimaryMetalType(filters))
  errs = errs.concat(validatorFactory.validatePrimaryDiamond(filters))
  errs = errs.concat(validatorFactory.validateRing(filters))
  errs = errs.concat(validatorFactory.validateBail(filters))
  errs = errs.concat(validatorFactory.validatePendantChain(filters))
  errs = errs.concat(validatorFactory.validateBasketType(filters))
  errs = errs.concat(validatorFactory.validateProng(filters))
  errs = errs.concat(validatorFactory.validateAdditionalDiamond(filters))
  errs = errs.concat(validatorFactory.validateStockItem(filters))
  errs = errs.concat(validatorFactory.validateAdditionalOption(filters))
  errs = errs.concat(validatorFactory.validateAdditionalChargeCurrency(filters))
  return errs
}

// Expose all the validation functions as validatorFactory to make them compatible with sinon spy and stub
// Because when a function is invoked by another one in the same file, the reference is not via the export, which makes it untracable by sinon
// By centralizing the reference of the functions via an object 'validatorFactory', they are now tracable by sinon
export const validatorFactory = {
  validateJewelryType,
  validatePrimaryMetalType,
  validateHaloSideDiamond,
  validatePrimaryDiamondHalo,
  validatePrimaryDiamond,
  validateMultiStoneHalo,
  validateMultiStone,
  validateShankTopDiamond,
  validateShankSideDiamond,
  validateRing,
  validateBailDiamond,
  validateBail,
  validatePendantChain,
  validateBasketType,
  validateProng,
  validateAdditionalDiamond,
  validateStockItem,
  validateAdditionalOption,
  validateAdditionalChargeCurrency,
  validateForm
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validator.js